/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisionHistoryItem
 */
export interface RevisionHistoryItem {
    /**
     * Date and time of the revision
     * @type {Date}
     * @memberof RevisionHistoryItem
     */
    dateTime: Date;
    /**
     * User or system that performed the change
     * @type {string}
     * @memberof RevisionHistoryItem
     */
    user: string;
    /**
     * Functional area where the change occurred
     * @type {string}
     * @memberof RevisionHistoryItem
     */
    section: string;
    /**
     * Business context associated with the change
     * @type {string}
     * @memberof RevisionHistoryItem
     */
    details: string;
    /**
     * Name of the changed attribute
     * @type {string}
     * @memberof RevisionHistoryItem
     */
    attribute: string;
    /**
     * Value before the change
     * @type {string}
     * @memberof RevisionHistoryItem
     */
    previousValue: string;
    /**
     * Value after the change
     * @type {string}
     * @memberof RevisionHistoryItem
     */
    newValue: string;
}

/**
 * Check if a given object implements the RevisionHistoryItem interface.
 */
export function instanceOfRevisionHistoryItem(value: object): value is RevisionHistoryItem {
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('section' in value) || value['section'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('attribute' in value) || value['attribute'] === undefined) return false;
    if (!('previousValue' in value) || value['previousValue'] === undefined) return false;
    if (!('newValue' in value) || value['newValue'] === undefined) return false;
    return true;
}

export function RevisionHistoryItemFromJSON(json: any): RevisionHistoryItem {
    return RevisionHistoryItemFromJSONTyped(json, false);
}

export function RevisionHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisionHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'dateTime': (new Date(json['dateTime'])),
        'user': json['user'],
        'section': json['section'],
        'details': json['details'],
        'attribute': json['attribute'],
        'previousValue': json['previousValue'],
        'newValue': json['newValue'],
    };
}

export function RevisionHistoryItemToJSON(json: any): RevisionHistoryItem {
    return RevisionHistoryItemToJSONTyped(json, false);
}

export function RevisionHistoryItemToJSONTyped(value?: RevisionHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dateTime': value['dateTime'].toISOString(),
        'user': value['user'],
        'section': value['section'],
        'details': value['details'],
        'attribute': value['attribute'],
        'previousValue': value['previousValue'],
        'newValue': value['newValue'],
    };
}

